export class RouletteBetConfiguration {
    //******************************************************************************************************************
    //  Bets
    //******************************************************************************************************************

    public static Single: Array<number>;
    public static SplitVertical: Array<number>;
    public static SplitHorizontal: Array<number>;
    public static Street: Array<number>;
    public static Corner: Array<number>;
    public static DoubleStreet: Array<number>;
    public static Trio: Array<number>;
    public static FirstFour: Array<number>;
    public static Basket: Array<number>;
    public static LowOrHigh: Array<number>;
    public static RedOrBlack: Array<number>;
    public static EvenOrOdd: Array<number>;
    public static Dozen: Array<number>;
    public static Column: Array<number>;

    //basket not included yet
    public static readonly AllTypes: Array<string> = [
        "Single",
        "SplitVertical",
        "SplitHorizontal",
        "Street",
        "Corner",
        "DoubleStreet",
        "Trio",
        "FirstFour",
        "LowOrHigh",
        "RedOrBlack",
        "EvenOrOdd",
        "Dozen",
        "Column",
    ];

    public static readonly RacetrackAllTypes: Array<string> = [
        "R_",
        "R_tiers",
        "R_orphelins",
        "R_voisins",
        "R_zeroGame",
    ];
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/RouletteBetConfiguration.ts
 **/